import { createReducer } from 'redux-act';
import {
  BOOKING_CREATE_INIT,
  BOOKING_CREATE_SUCCESS,
  BOOKING_CREATE_FAIL,
  BOOKING_FETCH_INIT,
  BOOKING_FETCH_SUCCESS,
  BOOKING_FETCH_FAIL,
  BOOKING_FETCH_BY_ID_INIT,
  BOOKING_FETCH_BY_ID_SUCCESS,
  BOOKING_FETCH_BY_ID_FAIL,
  BOOKING_UPDATE_INIT,
  BOOKING_UPDATE_SUCCESS,
  BOOKING_UPDATE_FAIL,
  BOOKING_DELETE_INIT,
  BOOKING_DELETE_SUCCESS,
  BOOKING_DELETE_FAIL,
} from '../actions/booking';

const initialState = {
  loading: false,
  bookings: [],
  currentBooking: null,
  error: null,
};

const booking = createReducer(
  {
    [BOOKING_CREATE_INIT]: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    [BOOKING_CREATE_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      bookings: [...state.bookings, payload.booking],
      error: null,
    }),
    [BOOKING_CREATE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [BOOKING_FETCH_INIT]: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    [BOOKING_FETCH_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      bookings: payload.bookings,
      error: null,
    }),
    [BOOKING_FETCH_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [BOOKING_FETCH_BY_ID_INIT]: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    [BOOKING_FETCH_BY_ID_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      currentBooking: payload.booking,
      error: null,
    }),
    [BOOKING_FETCH_BY_ID_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [BOOKING_UPDATE_INIT]: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    [BOOKING_UPDATE_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      currentBooking: payload.booking,
      bookings: state.bookings.map(booking => 
        booking._id === payload.booking._id ? payload.booking : booking
      ),
      error: null,
    }),
    [BOOKING_UPDATE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [BOOKING_DELETE_INIT]: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    [BOOKING_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      bookings: state.bookings.filter(booking => booking._id !== payload.bookingId),
      error: null,
    }),
    [BOOKING_DELETE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
  },
  initialState
);

export default booking;